export const extractSecureRedirectTo = (redirectTo: string | undefined | null): string | undefined => {
  if (!redirectTo) {
    return undefined;
  }

  if (redirectTo === '') {
    return redirectTo;
  }

  if (redirectTo.startsWith('/')) {
    return redirectTo;
  }

  const currentHostname = window.location.hostname;
  try {
    const url = new URL(redirectTo);
    if (url.hostname === currentHostname) {
      return redirectTo;
    }
  } catch (e) {
    console.error('Invalid redirect URL:', redirectTo, e);
    return undefined;
  }
};
